import { API_USER_SERVICE } from "../config/Constants";
import { getRequest, putRequest } from "./Rest";
import axios from "axios";

export const getWarehouseById = async (id: number) => {
    const path = `${API_USER_SERVICE}/warehouse/${id}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const updateWarehouse = async (id: number, formData: FormData) => {
    const path = `${API_USER_SERVICE}/warehouse/${id}`;
    
    const token = sessionStorage.getItem("token");
    const response = await axios.put(path, formData, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
};

export const getPincodeCount = async () => {
    const path = `${API_USER_SERVICE}/delivery-pincodes/count`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getAllPincodes = async () => {
    const path = `${API_USER_SERVICE}/delivery-pincodes`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getAdminInfo = async (warehouseId: number) => {
    const path = `${API_USER_SERVICE}/user/admin-info/${warehouseId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getWarehouseCapacity = async (warehouseId: number) => {
    const path = `${API_USER_SERVICE}/orders/stats/warehouse-capacity?warehouseId=${warehouseId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data;
    return dataResponse;
};